import { Injectable, inject } from '@angular/core';
import { Title } from '@angular/platform-browser';

@Injectable({
  providedIn: 'root'
})
export class TitleService {
  private titleService = inject(Title);

  webName = 'Aztalena';

  setTitle(title: string): void {
    if (title) {
      this.titleService.setTitle(title + ' - ' + this.webName);
    } else {
      this.titleService.setTitle(this.webName);
    }
  }
}
